import Api from "@/service/api";
export async function getEventById<T>(id: string) {
  return Api.request<T>({
    url: "/askpaul/event/" + id,
    method: "GET"
  });
}

export async function getOrdersByEventId<T>(id: string) {
  return Api.request<T>({
    url: "/askpaul/orders/event/" + id,
    method: "GET"
  });
}

// AskPaul-Market价格趋势
export async function getMarketPriceTrendsById<T>(id: string | number) {
  return Api.request<T>({
    url: "/askpaul/market_price-trends/" + id,
    method: "GET"
  });
}